import { StrictMode } from "react";
import reactDomClient from "react-dom/client";
import { App } from "./App";
import "@supermanus/editor/styles.css";
import "./app.css";

const el = document.getElementById("root");
if (!el) throw new Error("Missing #root");

reactDomClient.createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
